import React from 'react';
import { Progress, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  current: number;
  limit: number; // -1 は無制限
  label: string;
}

/**
 * 使用量バー（antd Progress）。80%で警告色、100%で例外色。
 */
export const UsageBar: React.FC<Props> = ({ current, limit, label }) => {
  const { t } = useTranslation();
  const isUnlimited = limit === -1;
  const percent = isUnlimited || limit === 0 ? 0 : Math.min((current / limit) * 100, 100);
  const isFull = !isUnlimited && current >= limit;
  const isNear = !isUnlimited && percent >= 80;

  const status = isFull ? 'exception' : 'normal';

  return (
    <div style={{ marginBottom: 12 }}>
      <Space style={{ width: '100%', justifyContent: 'space-between' }}>
        <Typography.Text>{label}</Typography.Text>
        <Typography.Text type="secondary">
          {current} / {isUnlimited ? t('usage.unlimited') : limit}
        </Typography.Text>
      </Space>
      {!isUnlimited && (
        <Progress percent={Math.round(percent)} status={status} showInfo={false} />
      )}
      {isFull && (
        <Typography.Text type="danger" style={{ fontSize: 12 }}>
          {t('usage.limitReached')}
        </Typography.Text>
      )}
      {!isFull && isNear && (
        <Typography.Text type="warning" style={{ fontSize: 12 }}>
          {t('usage.nearLimit')}
        </Typography.Text>
      )}
    </div>
  );
};
